import React, { useEffect, useState } from 'react';

import Card from '@material-ui/core/Card';
import CardContent from '@material-ui/core/CardContent';
import CheckBox from '@material-ui/core/Checkbox';
import Grid from '@material-ui/core/Grid';
import LinearProgress from '@material-ui/core/Grid';
import { makeStyles } from '@material-ui/core/styles';
import isEqual from 'lodash/isEqual';

import grocers from 'data/grocers';
import useAuth from 'hooks/useAuth';
//import useSnack from 'hooks/useSnack';
import load from 'hooks/utils/dbLoader';
import { dbSet } from 'hooks/utils/dbUpdater';
import { addEvent } from 'hooks/utils/events';
import { trace } from 'utils';

// import DislikedIngredients from './DislikedIngredients';

// import { preCacheMeals } from 'hooks/utils/fillMeals';

const useStyles = makeStyles((theme) => ({
  input: {
    width: 42,
  },
  label: {
    fontSize: '1.2em',
    [theme.breakpoints.down('xs')]: {
      fontSize: '1.1em',
    },
  },
  icon: {
    [theme.breakpoints.down('xs')]: {
      fontSize: 18,
    },
  },
  chip: {
    minWidth: 100,
    marginBottom: 8,
    marginRight: 16,
    [theme.breakpoints.down('xs')]: {
      minWidth: 70,
      fontSize: '.7em',
      marginRight: 12,
    },
  },
  activeChip: {
    marginRight: 8,
  },
  grow: {
    flexGrow: 1,
  },
  container: {
    paddingLeft: 8,
    paddingRight: 8,
    [theme.breakpoints.up('md')]: {
      paddingLeft: '10%',
      paddingRight: '10%',
    },
    marginBottom: 100,
  },
  sectionHeader: {
    marginTop: 30,
  },
  sectionBody: {
    marginTop: 10,
    paddingLeft: 10,
    paddingRight: 10,
  },
  buttons: {
    marginTop: 5,
    textAlign: 'right',
    [theme.breakpoints.up('md')]: {
      width: '100%',
    },
    [theme.breakpoints.up('lg')]: {
      position: 'absolute',
      right: 10,
      top: 10,
      width: 'auto',
    },
  },
  saveButton: {
    marginRight: 10
  }
}));

const defaultValue = {};

const OnlinePreferences = ({ state, setState, step, finishStep, enableNext }) => {
  const classes = useStyles();
  const { uid } = useAuth();
  //const { setSnack } = useSnack();
  const [pageState, setPageState] = useState('loading');

  useEffect(() => {
    if (uid) {
      load({ path: 'household/onlinePreferences', uid, defaultValue }).then((result) => {
        setPageState({ onlinePreferences: result });
      });
    }
  }, [uid, setPageState]);


  useEffect(() => {
    if (step.id === 'onlinePreferences' && step.entering) {
      if (state.household) {
        trace('Loading online preferences: %o', state.household.onlinePreferences);
        setPageState((pageState) => ({
          ...pageState,
          onlinePreferences: { ...state.household.onlinePreferences }
        }));
      }
      enableNext(true);
    }
}, [enableNext, step, uid, setPageState, state.household?.onlinePreferences]);

  

useEffect(() => {
  if (step.id === 'onlinePreferences' && step.exiting) {
    // Store in database
    dbSet({ uid, path: 'household/onlinePreferences', value: pageState.onlinePreferences });  // Fixed typo here

    setState((state) => {
      // Check if state and state.household are defined to prevent errors
      if (state && state.household) {
        if (!isEqual(pageState.onlinePreferences, state.household.onlinePreferences)) {
          trace('Actually updating online preferences: %o != %o', pageState.onlinePreferences, state.household.onlinePreferences);
          return { 
            ...state, 
            household: {
                ...state.household,
                onlinePreferences: pageState.onlinePreferences  // Fixed the usage here
            } 
          };
        }
      }
      return state;
    });
    finishStep();
  }
}, [step, pageState, setState, uid, finishStep]);


  if (step.id !== 'onlinePreferences') {
    return null;
  }

  if (pageState === 'loading') {
    return null;
  }

  const toggleGrocer = (id, checked) => {
    setPageState((current) => {
      const newState = {
        onlinePreferences: { ...current.onlinePreferences, [id]: checked }
      };
      console.log('new: %o', newState);

      dbSet({ uid, path: 'household/onlinePreferences', value: newState.onlinePreferences }).then(() => {
        addEvent({ action: 'saveOnlinePreferences', category: 'activity', uid, data: newState.onlinePreferences });
      });
      
      return newState;
    });
  };

  const getGrocerLogoPath = (grocerId) => {
    try {
      return require(`assets/GroceryLogos/${grocerId}.png`);
    } catch (error) {
      // If the logo file is not found, return a default image or handle the error in a desired way.
      return require('assets/GroceryLogos/missinglogo.png');
    }
  };

  if (pageState === 'loading') {
    return <LinearProgress />;
  }

  return (
    <Grid container item direction="column" justifyContent="flex-start" className={classes.container}>
      <h3>Choose your preferred online grocers now or set them later:</h3>
      <Grid item container spacing={1}>
        {Object.values(grocers).map((g) => (
          <Grid key={g.id} item xs={6} sm={4} lg={3}>
            <Card
              variant="outlined"
              style={{ height: '140px', minHeight: '140px', display: 'flex', flexDirection: 'column', justifyContent: 'center', position: 'relative' }}
            >
              <CheckBox
                checked={!!pageState.onlinePreferences[g.id]}
                onChange={(ev) => toggleGrocer(g.id, ev.target.checked)}
                style={{ position: 'absolute', top: '5px', left: '5px', zIndex: 1 }}
              />
              <CardContent style={{ flex: 1 , display: 'flex', alignItems: 'center', justifyContent: 'center'}}>
                <img
                  src={getGrocerLogoPath(g.id)}
                  alt={g.name}
                  style={{ height: '100px', width: '100px', objectFit: 'contain' }}
                />
              </CardContent>
            </Card>
          </Grid>
        ))}
      </Grid>
    </Grid>
  );
};


export default OnlinePreferences;

